export const FETCH_EVALUATION_METRICS = "FETCH_EVALUATION_METRICS";
export const FETCH_DETAIL_METRICS = "FETCH_DETAIL_METRICS";
export const CREATE_EVALUATION_METRICS = "CREATE_EVALUATION_METRICS";
export const EDIT_EVALUATION_METRICS = "EDIT_EVALUATION_METRICS";
export const DELETE_EVALUATION_METRICS = "DELETE_EVALUATION_METRICS";
